const submenuItems = [
  {
    header: 'Finding Affordable Home Insurance',
    items: [
      { title: 'How Much is Homeowners Insurance?', url: '/homeowners-insurance/how-much-does-homeowners-insurance-cost/', },
      { title: 'Bundling Home & Auto Insurance', url: '/homeowners-insurance/bundling-home-and-auto-insurance/', },
      { title: 'Home Insurance Discounts', url: '/blog/new-homeowners-save-on-homeowners-insurance-discounts/', },
      { title: 'What to Do When Your Rates Rise', url: '/homeowners-insurance/why-did-my-homeowners-insurance-rates-go-up/', },
    ],
  },
  {
    header: 'Helpful Resources',
    items: [
      { title: 'How to Shop for Home Insurance', url: '/homeowners-insurance/how-to-buy-homeowners-insurance/', },
      { title: 'What Does Homeowners Insurance Cover?', url: '/homeowners-insurance/what-does-homeowners-insurance-cover/', },
      { title: 'Choosing a Homeowners Insurance Deductible', url: '/homeowners-insurance/what-is-a-homeowners-insurance-deductible/', },
      { title: 'Best Home Insurance Companies', url: '/homeowners-insurance/best-homeowners-insurance-companies/', },
    ],
  },
  {
    header: 'Home Insurance Company Reviews',
    items: [
      { title: 'Safeco', url: '/homeowners-insurance/reviews/safeco/', },
      { title: 'MetLife', url: '/homeowners-insurance/reviews/metlife/', },
      { title: 'Travelers', url: '/homeowners-insurance/reviews/travelers/', },
      { title: 'Hippo', url: '/homeowners-insurance/reviews/hippo/', },
      { title: 'View All Companies', url: '/homeowners-insurance/reviews/', },
    ],
  },

];

export default {
  menu: {
    header: 'Homeowners Insurance',
    shortHeader: 'Homeowners',
    link: '/homeowners-insurance/',
    activeName: 'homeowners-insurance',
    columns: 2,
  },
  intro: {
    cta: 'Get a Free Quote',
    icon: 'homeownersColor',
    linkHref: '/homeowners-insurance/',
    secondaryLinkHref: '/homeowners-insurance/learn/',
  },
  list: {
    alt: 'Homeowners Insurance',
    items: submenuItems,
    type: 'links',
  }
};



// WEBPACK FOOTER //
// ../src/templates/MainNav/data/products/homeData.js